import { useEffect, useRef, useState } from "react";

const TruncateTest = ({ description }) => {
  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [description]);

  const onClickshowMoreProducts = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      {!!description && (
        <div className={`heading13px mt2 position-relative`}>
          <span ref={textRef} className={showMore ? "" : "truncate-text"}>
            {description}
          </span>
          {isOverflowing && (
            <span
              className={`fw-bold text-theme cursor-pointer ml10 ${showMore ? "" : "read-more position-absolute"}`}
              onClick={onClickshowMoreProducts}
            >
              {showMore ? "Hide" : "Read more>>"}
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default TruncateTest;
